import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import Image from 'mui-image';

const Navbar = () => {
  return (
    <>
      <AppBar
        style={{
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            pl: { xs: 0, md: 2 }, // xs = mobile, md = desktop
            pr: { xs: 0, md: 2 },
          }}
        >
          <Box
            sx={{
              height: { xs: '68px', xl: '92px' },
              width: { xs: '100px', xl: '128px' },
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <IconButton disableRipple>
              <Image
                src={require('../../assets/irace_web_logo.png')}
                alt={'irace'}
                style={{
                  height: '90%',
                  width: '90%',
                  objectFit: 'contain',
                  marginLeft: '85px',
                }}
              />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Spacer supaya konten gak ketiban AppBar */}
      {/* <Toolbar /> */}
    </>
  );
};

export default Navbar;
